<template>
	<div class="manufacuring-exection-system-list">
		<div class="manufacuring-exection-system-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">MES（Manufacturing Execution System） </span>
			</div>

			<div class="list">
				<ul>
					<li><img :src="solution_image_01" alt="Xhorse"/></li>
					<li>
						<div class="dd">
							<ul>
								<li>-Traceability</li>
								<li>-WIP Control</li>
								<li>
									<h3>Equipment/PLC automatic connection</h3>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Computer Integrated Manufacturing: CI</p></div>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Equipment Automation Program: EAP</p></div>
								</li>
								<li>
									<h3>Professional QMS</h3>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Statistical Process Control: SPC</p></div>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Corrective Action Report: CAR</p></div>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Out of Control Action Plan: OCAP</p></div>
								</li>
								<li>
									<h3>Equipment Procedures Management</h3>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Equipment Management System: EMS</p></div>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Overall Equipment Effectiveness: OEE</p></div>
								</li>
								<li>
									<h3>Real-time Production Report</h3>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">Yield Rate Report</p></div>
									<div>
										<span class="x-inline vv">-</span>
										<p class="x-inline">WIP Report</p></div>
								</li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_intellgent_01.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
            };
        }
    }

</script>

<style scoped="">
	.dd p {
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.375rem;
	}

	h3 {
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.375rem;
	}

	.vv {
		width: 1.25rem;
		text-align: right;
	}

	.dd {
		width: 100%;
		height: 100%;
	}

	.dd > ul > li {
		width: 100%;
		text-align: left;
		margin-bottom: 1.375rem;
	}

	.list > ul > li > img {
		width: 100%;
	}

	.list > ul > li {
		width: calc((100% - 3.8125rem) / 2);
		height: 27.5rem;
		float: left;
	}

	.list > ul > li:nth-child(2) {
		margin-left: 3.8125rem;
	}

	.list > ul {
		width: 100%;
		height: 27.5rem;
		border: none;
	}

	.manufacuring-exection-system-con {
		width: 61.5rem;
		border: none;
		margin-left: 0;
	}

	.manufacuring-exection-system-list {
		width: 61.5rem;
		height: 34.1875rem;
		border: none;
	}

	.list {
		width: 54.5rem;
		height: 34.5rem;
		border: none;
		margin-left: 7rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-manufacturing-execution-system.vue